<template>
  <body class="__variable_f4926d __variable_5c52a9">
    <div>
      <noscript
        ><img
          src="https://sb.scorecardresearch.com/p?c1=2&amp;c2=20631572&amp;cv=3.6.0&amp;cj=1"
      /></noscript>
      <header class="curseforge-header">
        <nav>
          <button class="mobile-menu-opener" aria-label="Navigation Menu">
            <svg viewBox="0 0 24 24">
              <path
                class="hamburger-top"
                d="M2,4v-2h20v2z"
                fill="currentcolor"
              ></path>
              <path
                class="hamburger-middle"
                d="M2,12v-2h20v2z"
                fill="currentcolor"
              ></path>
              <path
                class="hamburger-bottom"
                d="M2,20v-2h20v2z"
                fill="currentcolor"
              ></path>
            </svg>
          </button>
          <!-- <a
            href="/"
            class="curseforge-logo"
            title="curse forge"
            aria-label="Goto home page"
          >
            <img class="desktop-logo" :src="topLogo" />
          </a> -->
          <div class="nav-links-container">
            <ul class="nav-links">
              <li>
                <a href="/" class="nav-link">Browse</a>
                <div class="sub-nav-container">
                  <div class="sub-nav">
                    <div class="mover" style="width: 0"></div>
                    <div class="sub-nav-inner">
                      <div class="sub-nav-block">
                        <h2>
                          <a href="/" class="more-link">Browse all (107)</a>
                        </h2>
                        <ul class="sub-nav-links-list">
                          <li>
                            <a
                              href="/"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/13/638605220544214742.webp"
                              />Minecraft</a
                            >
                          </li>
                          <li>
                            <a
                              href="/sims4"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/17/638605223094593241.webp"
                              />The Sims 4</a
                            >
                          </li>
                          <li>
                            <a
                              href="/wow"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/63/986/636148993918069601.png"
                              />World of Warcraft</a
                            >
                          </li>
                          <li>
                            <a
                              href="/ark-survival-ascended"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/18/638605223934776497.webp"
                              />Ark Survival Ascended</a
                            >
                          </li>
                          <li>
                            <a
                              href="/minecraft-bedrock"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/652/316/638053973637065420.png"
                              />Minecraft Bedrock</a
                            >
                          </li>
                          <li>
                            <a
                              href="/sc2"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/16/638605222444192313.webp"
                              />StarCraft II</a
                            >
                          </li>
                          <li>
                            <a
                              href="/kerbal"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/101/638605301275466053.webp"
                              />Kerbal Space Program</a
                            >
                          </li>
                          <li>
                            <a
                              href="/american-truck-simulator"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/652/739/638054967147418836.png"
                              />American Truck Simulator</a
                            >
                          </li>
                          <li>
                            <a
                              href="/stardewvalley"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1070/14/638605221454973991.webp"
                              />Stardew Valley</a
                            >
                          </li>
                          <li>
                            <a
                              href="/terraria"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/65/488/636162973579653614.png"
                              />Terraria</a
                            >
                          </li>
                          <li>
                            <a
                              href="/wildstar"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/652/762/638054972820516108.png"
                              />WildStar</a
                            >
                          </li>
                          <li>
                            <a
                              href="/hogwarts-legacy"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/1069/302/638604223320170936.png"
                              />Hogwarts Legacy</a
                            >
                          </li>
                          <li>
                            <a
                              href="/worldoftanks"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/77/677/636174916166063366.png"
                              />World of Tanks</a
                            >
                          </li>
                          <li>
                            <a
                              href="/palworld"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/936/141/638413534976321166.jpg"
                              />Palworld</a
                            >
                          </li>
                          <li>
                            <a
                              href="/rom"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/76/698/636173120361240569.png"
                              />Runes of Magic</a
                            >
                          </li>
                          <li>
                            <a
                              href="/rift"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/652/751/638054969923607845.png"
                              />Rift</a
                            >
                          </li>
                          <li>
                            <a
                              href="/skyrim"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/77/689/636174976208356224.png"
                              />The Elder Scrolls V: Skyrim</a
                            >
                          </li>
                          <li>
                            <a
                              href="/teso"
                              class="sub-nav-link"
                              target=""
                              rel="noopener noreferrer"
                              ><img
                                id="row-image"
                                alt="icon"
                                loading="lazy"
                                width="24"
                                height="24"
                                decoding="async"
                                data-nimg="1"
                                style="color: transparent"
                                src="https://media.forgecdn.net/avatars/77/188/636173283407439352.png"
                              />The Elder Scrolls Online</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="sub-nav-block" style="width: 288px">
                        <h2>Hackathon now live</h2>
                        <a
                          href="https://links.overwolf.com/4hxyULS"
                          aria-label="Hackathon now live Promo"
                          ><img
                            width="288"
                            height="184"
                            src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_cca6a556-d5f8-4ecd-b5a6-620a04598d25.webp"
                            alt=""
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="/" class="nav-link">Create</a>
                <div class="sub-nav-container">
                  <div class="sub-nav">
                    <div class="mover" style="width: 0"></div>
                    <div class="sub-nav-inner">
                      <div class="sub-nav-block">
                        <h2>MOD AUTHORS</h2>
                        <ul class="sub-nav-links-list">
                          <li>
                            <a
                              href="http://authors.curseforge.com/welcome"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Become an Author</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://authors.curseforge.com/#/projects/create/choose-game"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Start a Project</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://support.curseforge.com/en/support/solutions/articles/9000199552-project-submission-guide-and-tips"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Project Submission Guide</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="sub-nav-block">
                        <h2>MODDING TOOL DEVELOPERS</h2>
                        <ul class="sub-nav-links-list">
                          <li>
                            <a
                              href="https://support.curseforge.com/en/support/solutions/articles/9000208346-about-the-curseforge-api-and-how-to-apply-for-a-key"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Apply for an API Key</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://docs.curseforge.com/rest-api/#getting-started"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Documentation</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://support.curseforge.com/en/support/solutions/articles/9000207405-curse-forge-3rd-party-api-terms-and-conditions"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Terms &amp; Conditions</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="sub-nav-block">
                        <h2>SOCIAL</h2>
                        <ul class="sub-nav-links-list">
                          <li>
                            <a
                              href="https://discord.gg/S3EaZArYz2"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Join Our Discord!</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="sub-nav-block" style="width: 288px">
                        <h2>Hackathon now live</h2>
                        <a
                          href="https://links.overwolf.com/4hgtCog"
                          aria-label="Hackathon now live Promo"
                          ><img
                            width="288"
                            height="184"
                            src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_3905d135-21c3-4a17-8954-a5ac3fa1ec29.webp"
                            alt=""
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="/" class="nav-link">Studios</a>
                <div class="sub-nav-container">
                  <div class="sub-nav">
                    <div class="mover" style="width: 0"></div>
                    <div class="sub-nav-inner">
                      <div class="sub-nav-block">
                        <h2>GAME DEVELOPERS</h2>
                        <ul class="sub-nav-links-list">
                          <li>
                            <a
                              href="https://studios.curseforge.com"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Unlock Modding for Your Game</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://docs.curseforge.com/"
                              class="sub-nav-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >Documentation</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="sub-nav-block" style="width: 288px">
                        <h2>CurseForge chosen for Hogwarts Legacy modding</h2>
                        <a
                          href="http://links.overwolf.com/3PnWuyL"
                          aria-label="CurseForge chosen for Hogwarts Legacy modding Promo"
                          ><img
                            width="288"
                            height="184"
                            src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_1fb15ce2-efb0-40e8-831b-0324ae16b478.webp"
                            alt=""
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="mobile-more-options">
              <li class="kebab-menu-divider"></li>
              <li>
                <a class="kebab-menu-link" href="/"
                  ><img
                    src="https://static-beta.curseforge.com/images/cf_legacy.png"
                    alt="legacy flame"
                  />Legacy</a
                >
              </li>
            </ul>
          </div>
          <ul class="top-actions">
            <li>
              <a
                class="link-btn btn-secondary premium-button-container link-btn-icon"
                href="/"
                target="_self"
                data-tooltip-id="curseforge-tooltip"
                data-tooltip-content="Go Premium"
                rel="  noopener"
              >
                <div class="premium-button-text">Go Premium</div></a
              >
            </li>
            <li>
              <a
                class="link-btn btn-primary link-btn-icon"
                href="/"
                target="_self"
                data-tooltip-id="curseforge-tooltip"
                data-tooltip-content="Get CurseForge App"
                rel="  noopener"
              >
                <div class="download-app-button-text">
                  Get CurseForge App
                </div></a
              >
            </li>
          </ul>
          <div class="divider"></div>
          <div class="header-kebab">
            <button class="kebab-button" aria-label="More options">
              <svg id="icon-kebab" viewBox="0 0 20 21">
                <path
                  d="M10 5.76172C11.1046 5.76172 12 4.86629 12 3.76172C12 2.65715 11.1046 1.76172 10 1.76172C8.89543 1.76172 8 2.65715 8 3.76172C8 4.86629 8.89543 5.76172 10 5.76172Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M12 10.7617C12 11.8663 11.1046 12.7617 10 12.7617C8.89543 12.7617 8 11.8663 8 10.7617C8 9.65715 8.89543 8.76172 10 8.76172C11.1046 8.76172 12 9.65715 12 10.7617Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M12 17.7617C12 18.8663 11.1046 19.7617 10 19.7617C8.89543 19.7617 8 18.8663 8 17.7617C8 16.6571 8.89543 15.7617 10 15.7617C11.1046 15.7617 12 16.6571 12 17.7617Z"
                  fill="currentColor"
                ></path>
              </svg>
            </button>
            <ul class="menu">
              <li>
                <a class="kebab-menu-link" href="/">Surprise me</a>
              </li>
              <li class="kebab-menu-divider"></li>
              <li>
                <a class="kebab-menu-link" href="/"
                  ><img
                    src="https://static-beta.curseforge.com/images/cf_legacy.png"
                    alt="legacy flame"
                  />Legacy</a
                >
              </li>
            </ul>
          </div>
          <div class="user-actions">
            <a
              class="link-btn btn-login btn-lined login-button-container link-btn-icon"
              href="/"
              target="_self"
              data-tooltip-id="curseforge-tooltip"
              data-tooltip-content="Login"
              rel="nofollow noreferrer noopener"
            >
              <div class="login-button-text">Login</div></a
            >
          </div>
        </nav>
      </header>
      <div>
        <div class="game-header">
          <div class="hero-container">
            <img
              src="https://media.forgecdn.net/game-covers/432_5076448d-feda-439b-9d63-ce86b70459ef.webp"
              alt="header"
            />
            <div class="desktop-only"></div>
          </div>
        </div>
        <div class="container">
          <div class="game-description">
            <div class="game-title">
              Well come to <span>{{ proName }}</span>
            </div>
          </div>
          <main class="game-page">
            <div class="discovery-carousel">
              <iframe
                id="gameFrame"
                class="game-frame"
                :src="frameUrl"
                title="War Checkers"
                frameborder="0"
                allowfullscreen=""
              ></iframe>
            </div>
            <section class="shelf">
              <div class="inner">
                <h2>Latest Mods</h2>
                <div class="content">
                  <ul class="tiles-list">
                    <li
                      class="project-tile medium"
                      v-for="item in gameList"
                      :key="item.id"
                      @click="navigateToGame(item.aHerf)"
                    >
                      <div class="tile">
                        <div class="art">
                          <img
                            id="row-image"
                            alt="AutoWhitelist project image"
                            loading="lazy"
                            width="228"
                            height="228"
                            decoding="async"
                            data-nimg="1"
                            style="color: transparent"
                            :src="item.gameImageUrl"
                          />
                        </div>
                        <a
                          class="overlay-link"
                          title="Go to AutoWhitelist Project Page"
                          aria-label="Go to AutoWhitelist Project Page"
                        ></a>
                        <div class="details">
                          <h3>
                            <a
                              href="/minecraft/mc-mods/autowhitelist"
                              title="Go to AutoWhitelist Project Page"
                              aria-label="Go to AutoWhitelist Project Page"
                              ><span class="ellipsis">{{
                                item.gameName
                              }}</span></a
                            >
                          </h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
            <section class="shelf">
              <div class="inner">
                <h2>Latest Modpacks</h2>
                <div class="content">
                  <ul class="tiles-list">
                    <li
                      class="project-tile medium"
                      v-for="item in gameBottomList"
                      :key="item.id"
                      @click="navigateToGame(item.aHerf)"
                    >
                      <div class="tile">
                        <div class="art">
                          <img
                            id="row-image"
                            alt="AutoWhitelist project image"
                            loading="lazy"
                            width="228"
                            height="228"
                            decoding="async"
                            data-nimg="1"
                            style="color: transparent"
                            :src="item.gameImageUrl"
                          />
                        </div>
                        <a
                          class="overlay-link"
                          title="Go to AutoWhitelist Project Page"
                          aria-label="Go to AutoWhitelist Project Page"
                        ></a>
                        <div class="details">
                          <h3>
                            <a
                              href="/minecraft/mc-mods/autowhitelist"
                              title="Go to AutoWhitelist Project Page"
                              aria-label="Go to AutoWhitelist Project Page"
                              ><span class="ellipsis">{{
                                item.gameName
                              }}</span></a
                            >
                          </h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
      <footer class="site-footer">
        <div class="site-footer-inner">
          <div class="slogan">
            CurseForge - a world of endless gaming possibilities for modders and
            gamers alike.<br />Download the best mods and addons!
          </div>
          <div class="site-footer-nav">
            <nav>
              <ul>
                <li>
                  <div class="section-header">Games</div>
                  <ul>
                    <li><a href="/games">All games</a></li>
                    <li><a href="/minecraft">Minecraft</a></li>
                    <li><a href="/wow">World of Warcraft</a></li>
                    <li><a href="/sims4">The Sims 4</a></li>
                    <li><a href="/sc2">Starcraft II</a></li>
                    <li><a href="/kerbal">Kerbal Space Program</a></li>
                    <li>
                      <a href="/minecraft-dungeons">Minecraft Dungeons</a>
                    </li>
                    <li><a href="/worldoftanks">World of Tanks</a></li>
                  </ul>
                </li>
                <li>
                  <div class="section-header">Create</div>
                  <ul>
                    <li>
                      <a
                        href="https://authors.curseforge.com/#/projects/create/choose-game"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Start a project</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/solutions/articles/9000199552-project-submission-guide-and-tips"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Project submission guide</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/solutions/articles/9000197898-rewards-program-terms-of-service"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Author Rewards Program</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/solutions/articles/9000208346-about-the-curseforge-api-and-how-to-apply-for-a-key"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Apply for an API Key</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/solutions/articles/9000207405-curse-forge-3rd-party-api-terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        >3rd Party API T&amp;C</a
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="section-header">Community</div>
                  <ul>
                    <li>
                      <a
                        href="https://discord.gg/S3EaZArYz2"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Join Our Discord!</a
                      >
                    </li>
                    <li>
                      <a
                        href="//curseforge-ideas.overwolf.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ideas Portal</a
                      >
                    </li>
                    <li>
                      <a
                        href="//blog.curseforge.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >CF blog</a
                      >
                    </li>
                    <li>
                      <a
                        href="//www.curseforge.com/download/app#StayUpdated"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Newsletter</a
                      >
                    </li>
                    <li>
                      <a
                        href="//trello.com/b/Slaz6xBq/curseforge-roadmap"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Roadmap</a
                      >
                    </li>
                    <li>
                      <a
                        href="//bukkit.org/forums/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        >Bukkit forums</a
                      >
                    </li>
                    <li>
                      <a
                        href="//www.curseforge.com/servers/minecraft"
                        target="_blank"
                        rel="noopener noreferrer"
                        >CurseForge Servers</a
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="section-header">Support</div>
                  <ul>
                    <li>
                      <a
                        href="//support.curseforge.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Knowledge base</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/solutions/articles/9000194900-curseforge-troubleshooting"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Troubleshooting</a
                      >
                    </li>
                    <li>
                      <a
                        href="//support.curseforge.com/en/support/tickets/new"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Contact us</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="half">
                  <div class="section-header">Companions</div>
                  <ul>
                    <li>
                      <a
                        href="//overwolf.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Overwolf</a
                      >
                    </li>
                    <li>
                      <a
                        href="//studios.curseforge.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        >CurseForge for Studios</a
                      >
                    </li>
                    <li>
                      <a
                        href="//tebex.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Tebex</a
                      >
                    </li>
                    <li>
                      <a
                        href="//nitropay.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Nitro</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="half">
                  <div class="section-header">CurseForge Brand</div>
                  <ul>
                    <li>
                      <a
                        href="https://www.figma.com/file/YYn36CxVpcT6aPKDXIH9JG/CurseForge-Brandbook?type=design&amp;node-id=0-1&amp;t=dvC0gPtyP36PQdsi-0"
                        target="_blank"
                        rel="noopener noreferrer"
                        >CurseForge Brand Guidelines</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <div class="footer-bottom">
            <ul>
              <li>
                <a
                  href="https://legal.overwolf.com/docs/overwolf/platform/platform-terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Terms of Service</a
                >
              </li>
              <li>
                <a
                  href="https://legal.overwolf.com/docs/overwolf/platform/platform-privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Privacy Policy</a
                >
              </li>
              <li>
                <a
                  href="//support.overwolf.com/en/support/solutions/articles/9000203492-licenses-we-use"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Licenses</a
                >
              </li>
              <li>
                <a
                  href="https://legal.overwolf.com/docs/curseforge/mod-authors-terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Mod Author Terms</a
                >
              </li>
              <li id="ncmp-consent-link" class="consent"></li>
            </ul>
          </div>
          <div class="copyright">
            ©
            <!-- -->2025 Overwolf. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
    <iframe
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe
    ><next-route-announcer style="position: absolute"></next-route-announcer>
    <div
      id="batBeacon805189385227"
      style="width: 0px; height: 0px; display: none; visibility: hidden"
    >
      <img
        id="batBeacon135845569993"
        width="0"
        height="0"
        alt=""
        src="https://bat.bing.com/action/0?ti=355018261&amp;tm=gtm002&amp;Ver=2&amp;mid=1c7ff597-327d-4c51-8704-d07a22c5760b&amp;bo=1&amp;sid=3146092006ca11f08b63b135a83f103f&amp;vid=0685a080d22311efbfe1e5a3554da555&amp;vids=0&amp;msclkid=N&amp;cdl=prestable_control_2&amp;uach=pv%3D10.0.0&amp;pi=918639831&amp;lg=zh-CN&amp;sw=1920&amp;sh=1080&amp;sc=24&amp;tl=Minecraft%20Mods%20%26%20Modpacks%20-%20CurseForge&amp;p=https%3A%2F%2Fwww.curseforge.com%2Fminecraft&amp;r=https%3A%2F%2Fwww.curseforge.com%2F&amp;lt=779&amp;evt=pageLoad&amp;sv=1&amp;cdb=AQAQ&amp;rn=904575"
        style="width: 0px; height: 0px; display: none; visibility: hidden"
      />
    </div>
    <iframe
      id="FledgeIFrameee86cb672c"
      src="https://bat.bing.com/s/fledge/MSFledgePage.html?UETEventStr=ti%253D355018261%2526tm%253Dgtm002%2526Ver%253D2%2526mid%253D1c7ff597-327d-4c51-8704-d07a22c5760b%2526bo%253D1%2526sid%253D3146092006ca11f08b63b135a83f103f%2526vid%253D0685a080d22311efbfe1e5a3554da555%2526vids%253D0%2526msclkid%253DN%2526cdl%253Dprestable_control_2%2526uach%253Dpv%25253D10.0.0%2526pi%253D918639831%2526lg%253Dzh-CN%2526sw%253D1920%2526sh%253D1080%2526sc%253D24%2526tl%253DMinecraft%252520Mods%252520%252526%252520Modpacks%252520-%252520CurseForge%2526p%253Dhttps%25253A%25252F%25252Fwww.curseforge.com%25252Fminecraft%2526r%253Dhttps%25253A%25252F%25252Fwww.curseforge.com%25252F%2526lt%253D779%2526evt%253DpageLoad%2526sv%253D1%2526cdb%253DAQAQ%2526"
      style="display: none"
    ></iframe>
    <div id="cookiebar" class="cookiebar">
      <div class="cookiebar-content">
        <span
          >We use cookies to improve your experience and increase the relevancy
          of content when using CurseForge. Our cookies are used for
          analytics,<br />optimization, and advertising operations.
          <a
            target="_blank"
            href="https://legal.overwolf.com/docs/overwolf/cookies-policy"
            >View our Cookies Policy</a
          ></span
        >
        <div role="button" id="cookiebar-ok" style="color: #ffffff !important">
          Got it
        </div>
      </div>
    </div>
  </body>
</template>
<script setup>
import { ref, created, onMounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const bottomLogo = require("@/assets/image/logo.jpg");
const topLogo = require("@/assets/image/logo-white.png");
// 菜单列表
const meunList = [
  {
    name: "Games",
    skipUrl: "/",
  },
  {
    name: "Mods",
    skipUrl: "/",
  },
  {
    name: "Collections",
    skipUrl: "/",
  },
  {
    name: "Media",
    skipUrl: "/",
  },
  {
    name: "Community",
    skipUrl: "/",
  },
  {
    name: "Support",
    skipUrl: "/",
  },
];
// 游戏列表
const gameList = ref([
  {
    gameName: "Paper Doll Fo",
    aHerf: "1",
    gameImageUrl: require("@/assets/image/gameImg/y1.png"),
    bigFlag: false,
    alt: "Paper Doll For Girls Dress Up",
    score: "8.0bn",
  },
  {
    gameName: "Color Link Challenge",
    aHerf: "2",
    gameImageUrl: require("@/assets/image/gameImg/y2.png"),
    bigFlag: false,
    alt: "Color Link Challenge",
    score: "8.0bn",
  },
  {
    gameName: "Car Jam Color",
    aHerf: "3",
    gameImageUrl: require("@/assets/image/gameImg/y3.png"),
    bigFlag: true,
    alt: "Car Jam Color",
    score: "8.0bn",
  },
  {
    gameName: "Happy Glass",
    aHerf: "4",
    gameImageUrl: require("@/assets/image/gameImg/y4.png"),
    bigFlag: false,
    alt: "Happy Glass",
    score: "8.0bn",
  },
  {
    gameName: "Slide Blocks",
    aHerf: "5",
    gameImageUrl: require("@/assets/image/gameImg/y5.png"),
    bigFlag: false,
    alt: "Slide Blocks Puzzle",
    score: "7.8bn",
  },
  {
    gameName: "Cannon Balls",
    aHerf: "6",
    gameImageUrl: require("@/assets/image/gameImg/y6.png"),
    bigFlag: false,
    alt: "Cannon Balls - Arcade",
    score: "7.8bn",
  },
]);
const proName = process.env.VUE_APP_PROJECTNAME;

// 底部游戏列表
const gameBottomList = ref([
  {
    gameName: "Basketball Sw",
    aHerf: "7",
    gameImageUrl: require("@/assets/image/gameImg/y7.png"),
    bigFlag: false,
    alt: "Basketball Swooshes",
    score: "7.8bn",
  },
  {
    gameName: "Build Tower",
    aHerf: "8",
    gameImageUrl: require("@/assets/image/gameImg/y8.png"),
    bigFlag: false,
    alt: "Build Tower",
    score: "7.8bn",
  },
  {
    gameName: "Mushroom Pop",
    aHerf: "9",
    gameImageUrl: require("@/assets/image/gameImg/y9.png"),
    bigFlag: false,
    alt: "Mushroom Pop",
    score: "7.8bn",
  },
  {
    gameName: "Jumper Bot",
    aHerf: "10",
    gameImageUrl: require("@/assets/image/gameImg/y10.png"),
    bigFlag: false,
    alt: "Jumper Bot",
    score: "7.8bn",
  },
  {
    gameName: "Ghost Float",
    aHerf: "11",
    gameImageUrl: require("@/assets/image/gameImg/y11.png"),
    bigFlag: false,
    alt: "Ghost Float",
    score: "7.6bn",
  },
  {
    gameName: "Flamingo Bing",
    aHerf: "12",
    gameImageUrl: require("@/assets/image/gameImg/y12.png"),
    bigFlag: false,
    alt: "Flamingo Bingo",
    score: "7.6bn",
  },
  {
    gameName: "Zombie Wipeou",
    aHerf: "13",
    gameImageUrl: require("@/assets/image/gameImg/y13.png"),
    bigFlag: false,
    alt: "Zombie Wipeout",
    score: "7.6bn",
  },
  {
    gameName: "Dd Pixel Slid",
    aHerf: "14",
    gameImageUrl: require("@/assets/image/gameImg/y14.png"),
    bigFlag: true,
    alt: "Dd Pixel Slide",
    score: "7.6bn",
  },
  {
    gameName: "Swipe The Pin",
    aHerf: "15",
    gameImageUrl: require("@/assets/image/gameImg/y15.png"),
    bigFlag: false,
    alt: "Swipe The Pin",
    score: "7.6bn",
  },
  {
    gameName: "Fire And Wate",
    aHerf: "21",
    gameImageUrl: require("@/assets/image/gameImg/y21.png"),
    bigFlag: false,
    alt: "Fire And Water Stickman",
    viewNum: 5555,
    score: "8.0bn",
  },
  {
    gameName: "2048 Champion",
    aHerf: "22",
    gameImageUrl: require("@/assets/image/gameImg/y22.png"),
    bigFlag: true,
    alt: "2048 Champion",
    viewNum: 2137,
    score: "7.8bn",
  },
  {
    gameName: "Clones",
    aHerf: "23",
    gameImageUrl: require("@/assets/image/gameImg/y23.png"),
    bigFlag: false,
    alt: "Clones",
    viewNum: 1555,
    score: "7.6bn",
  },
  {
    gameName: "Firefighter R",
    aHerf: "24",
    gameImageUrl: require("@/assets/image/gameImg/y24.png"),
    bigFlag: false,
    alt: "Firefighter Rescue Quest",
    viewNum: 780,
    score: "7.6bn",
  },
  {
    gameName: "Dragon's Defe",
    aHerf: "25",
    gameImageUrl: require("@/assets/image/gameImg/y25.png"),
    bigFlag: false,
    alt: "Dragon's Defense Reign Of Fire",
    viewNum: 1323,
    score: "5.6bn",
  },
  {
    gameName: "Chin Up Shin",
    aHerf: "26",
    gameImageUrl: require("@/assets/image/gameImg/y26.png"),
    bigFlag: true,
    alt: "Chin Up Shin Up",
    viewNum: 1209,
    score: "6.1bn",
  },
  {
    gameName: "Counter Craft",
    aHerf: "27",
    gameImageUrl: require("@/assets/image/gameImg/y27.png"),
    bigFlag: false,
    alt: "Counter Craft 5",
    viewNum: 879,
    score: "7.2bn",
  },
  {
    gameName: "The Bomb",
    aHerf: "28",
    gameImageUrl: require("@/assets/image/gameImg/y28.png"),
    bigFlag: true,
    alt: "The Bomb",
    viewNum: 860,
    score: "7.7bn",
  },
  {
    gameName: "Princesses At",
    aHerf: "29",
    gameImageUrl: require("@/assets/image/gameImg/y29.png"),
    bigFlag: false,
    alt: "Princesses At Horror School",
    viewNum: 531,
    score: "7.9bn",
  },
  {
    gameName: "Number Match",
    aHerf: "30",
    gameImageUrl: require("@/assets/image/gameImg/y30.png"),
    bigFlag: false,
    alt: "Number Match - Match Ten",
    viewNum: 768,
    score: "7.5bn",
  },
  {
    gameName: "Ultimate Noug",
    aHerf: "31",
    gameImageUrl: require("@/assets/image/gameImg/y31.png"),
    bigFlag: false,
    alt: "Ultimate Noughts &amp; Crosses",
    viewNum: 980,
    score: "7.1bn",
  },
  {
    gameName: "Arrowblob Puz",
    aHerf: "32",
    gameImageUrl: require("@/assets/image/gameImg/y32.png"),
    bigFlag: false,
    alt: "Arrowblob Puzzle Quest",
    viewNum: 988,
    score: "6.2bn",
  },
  {
    gameName: "Ascend",
    aHerf: "33",
    gameImageUrl: require("@/assets/image/gameImg/y33.png"),
    bigFlag: false,
    alt: "Ascend",
    viewNum: 586,
    score: "5.6bn",
  },
  {
    gameName: "Race",
    aHerf: "34",
    gameImageUrl: require("@/assets/image/gameImg/y34.png"),
    bigFlag: false,
    alt: "Race",
    viewNum: 245,
    score: "8.6bn",
  },
  {
    gameName: "Tanks Battle",
    aHerf: "35",
    gameImageUrl: require("@/assets/image/gameImg/y35.png"),
    bigFlag: false,
    alt: "Tanks Battle Field",
    viewNum: 856,
    score: "8.6bn",
  },
  {
    gameName: "Battlegrid On",
    aHerf: "36",
    gameImageUrl: require("@/assets/image/gameImg/y36.png"),
    bigFlag: false,
    alt: "Battlegrid Online Pvp Tank Battles",
    viewNum: 153,
    score: "8.8bn",
  },
  {
    gameName: "Pumpkin Of Go",
    aHerf: "37",
    gameImageUrl: require("@/assets/image/gameImg/y37.png"),
    bigFlag: false,
    alt: "Pumpkin Of Goo",
    viewNum: 122,
    score: "8.6bn",
  },
  {
    gameName: "Apostle's Cre",
    aHerf: "38",
    gameImageUrl: require("@/assets/image/gameImg/y38.png"),
    bigFlag: false,
    alt: "Apostle's Creed I",
    viewNum: 436,
    score: "7.9bn",
  },
  {
    gameName: "Zombie Runner",
    aHerf: "39",
    gameImageUrl: require("@/assets/image/gameImg/y39.png"),
    bigFlag: true,
    alt: "Zombie Runner",
    viewNum: 1152,
    score: "7.8bn",
  },
  {
    gameName: "Fruit Name Ju",
    aHerf: "40",
    gameImageUrl: require("@/assets/image/gameImg/y40.png"),
    bigFlag: false,
    alt: "Fruit Name Jump",
    viewNum: 867,
    score: "7.6bn",
  },
  {
    gameName: "Fruit Name Ju",
    aHerf: "41",
    gameImageUrl: require("@/assets/image/gameImg/y41.png"),
    bigFlag: false,
    alt: "Fruit Name Jump",
    viewNum: 867,
    score: "7.6bn",
  },
]);

const navigateToGame = (index) => {
  router.push({ name: "play", query: { gameId: index } });
};
const clickMenu = (item) => {
  router.push(item.skipUrl);
};
const gameId = ref("");
const frameUrl = ref("");
/**
 * adsense
 */
const clientId = process.env.VUE_APP_ADSENSEID;
const clientslotId = process.env.VUE_APP_ADSENSESLOTID;

const loadAds = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  // 创建并配置 <ins> 元素
  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";

  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);
  const adContainer = document.getElementById("ad-container");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const loadAds2 = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";
  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);

  const adContainer = document.getElementById("ad-container2");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const getGameIdFromUrl = () => {
  const urlParams = window.location.search;
  // 去掉查询字符串开头的 ?
  const paramsArray = urlParams.slice(1).split("&");

  // 查找 gameId 参数
  const gameIdParam = paramsArray.find((param) => param.startsWith("gameId="));

  if (gameIdParam) {
    const gameIdValue = gameIdParam.split("=")[1];

    if (gameIdValue) {
      gameId.value = gameIdValue;
      frameUrl.value = `https://xmxmy.com/gameTesting/${gameIdValue}/index.html`;
      console.log(frameUrl.value, "frameUrl.value");
    }
  }
};
onMounted(() => {
  // loadAds();
  // loadAds2();
  getGameIdFromUrl();
});
watch(
  () => route.query.gameId,
  (newGameIdValue) => {
    console.log(newGameIdValue, "newGameIdValue");
    if (newGameIdValue) {
      gameId.value = newGameIdValue;
      frameUrl.value = `https://xmxmy.com/gameTesting/${newGameIdValue}/index.html`;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      console.log(newGameIdValue, "newGameIdValue");
    }
  }
);
</script>

<style lang="scss" scoped>
</style>
